module.exports = __webpack_public_path__ + "static/media/Llibre_obert_NEGRE.67a3b89d.png";